import { useRef, useEffect } from 'react';
import { useMessageListContext } from 'stream-chat-react';

const useMessageListScrollShadows = ({ setOverflowBottom, setOverflowTop, }) => {
    const { listElement, scrollToBottom } = useMessageListContext();
    const headerRef = useRef(null);
    // setup resize observer to show/hide scroll shadows
    useEffect(() => {
        const handleResize = () => {
            if (listElement) {
                const hasOverflowBottom = listElement.scrollHeight - listElement.clientHeight >
                    listElement.scrollTop + 1;
                setOverflowBottom(hasOverflowBottom);
            }
        };
        const resizeObserver = new ResizeObserver(handleResize);
        resizeObserver.observe(listElement);
        return () => resizeObserver.unobserve(listElement);
    }, [listElement, setOverflowBottom]);
    // evaluate if scroll shadows are needed initially
    useEffect(() => {
        var _a;
        const { scrollTop, scrollHeight, clientHeight } = listElement;
        setOverflowTop(scrollTop > 0);
        setOverflowBottom(scrollHeight - clientHeight > scrollTop + 1);
        const headerHeight = (_a = headerRef === null || headerRef === undefined ? undefined : headerRef.current) === null || _a === undefined ? undefined : _a.offsetHeight;
        listElement.style.marginTop = `${headerHeight}px`;
        scrollToBottom();
    }, [listElement]);
    // setup scroll event listener to show/hide scroll shadows
    useEffect(() => {
        const handleScroll = () => {
            const { scrollTop, scrollHeight, clientHeight } = listElement;
            setOverflowTop(scrollTop > 0);
            setOverflowBottom(scrollHeight - clientHeight > scrollTop + 1);
        };
        listElement.addEventListener("scroll", handleScroll);
        return () => listElement.removeEventListener("scroll", handleScroll);
    }, [listElement, setOverflowTop, setOverflowBottom]);
    return { headerRef };
};

export { useMessageListScrollShadows };
//# sourceMappingURL=use_message_list_scroll_shadows.js.map
